import { formatEventTime } from "../../../../../EventCalendarEditor"
import { eventStageLabel } from "../../../../../EventStage"

const toTitleCase = value =>
  String(value || "")
    .replace(/(^\w{1})|(\s{1}\w{1})/g, match => match.toUpperCase())

// P72 (Tudor, 2026-10-26, variant B): what generating does to the event stage, for the stage the event is in (drawPublicationNotice).
// A draw generated while registrations are open also says that later entries are not in it.
export const statusNoticeLines = (notice, timezone) => {
  if (!notice) return []
  if (notice.kind === "now") return ["The event stage changes now from Draw pending to Ready to play, and the Main Draw is shown on the competition page."]
  if (notice.kind === "unchanged") return [`The event stage stays ${eventStageLabel(notice.stage)}. The new Main Draw replaces the one on the competition page.`]
  return [
    `Registrations are open until ${formatEventTime(notice.at, timezone)}. Then the event stage changes to Ready to play, skipping Draw pending, and the Main Draw is shown on the competition page.`,
    "Anyone who registers after it is generated is not in this draw.",
  ]
}

export const getMainDrawConfirmationCopy = confirmation => {
  const {
    drawModel,
    hasNoPhaseWarning = false,
    phaseId,
    statusNotice,
    timezone,
  } = confirmation || {}
  const body = [
    "Are you sure you want to generate the Main Draw?",
    "Generating the Main Draw can overwrite existing Main Draw matches if they were already generated.",
  ]

  if (hasNoPhaseWarning) {
    body.push(
      `There is no phase set for this ${toTitleCase(
        drawModel
      )} competition.`
    )
  }
  body.push(...statusNoticeLines(statusNotice, timezone))

  return {
    title: phaseId ? "Generate Phase Main Draw" : "Generate Main Draw",
    body,
    confirmLabel: "Yes, generate",
    cancelLabel: "No",
  }
}
